// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__es7Dw","innerContainer":"styles_innerContainer__lnIES","header":"styles_header__o7NL5","infoContainer":"styles_infoContainer__gHQ0p"};